<template>
  <div>
    <v-data-table
    id="lanswitchesTable"
    :headers="headers"
    :items="lanswitches"
    class="elevation-1"
    item-key="id"
    :items-per-page="-1"
    :hide-default-footer="true"
    >
    <template v-slot:[`item.lanswitchId`]="{ item }">
        <td :id="createElementId('id', item)" class="text-start">
            {{item.lanswitchId}}
        </td>
    </template>
    <template v-slot:[`item.delete`]="{ item }">
        <v-icon
        :id="createElementId('delete', item)"
        small
        @click="deleteItem()"
        >
        mdi-delete
        </v-icon>
        </template>
    </v-data-table>
  </div>
</template>

<script>
   /**
    *  The LanSwitchConfig component is a table where each row contains the configuration of a LAN Switch
    */
  export default {
    name: 'LanSwitchConfig',

    data: () => ({
       /**
        *  headers: columns displayed in the table
        */
        headers: [],
    }),

    /**
     *  vue-prop: lanswitches - the array of lanswitches where each LAN Switch is a row in the table
     *  vue-prop: showHardwareId - boolean to determine whether the lanswitchId should be shown as a column
     *  vue-prop: showDeleteButton - boolean to determine whether the delete button should be shown
     *  A list of lan switch config is used in the configuration page and testresultaten page.
     */
    props: {
        lanswitches: Array,
        showHardwareId: Boolean,
        showDeleteButton: Boolean
    },

    watch: {
        /**
         *  vue-event: lanswitchesListUpdated - when the list of lanswitches is changed the new list is sent to parent (Config.vue)
         */
        lanswitches: function (updatedList) {
            this.$emit('lanswitchesListUpdated', updatedList);
        }
    },

    /**
     *  The 'Id' column is only added to the table when the config shows a list of lanswitches.
     *  The delete icon is only added to the table when the config shows a list of lanswitches.
     */
    created () {
        if (this.showHardwareId) {
          this.headers.unshift({
            align: 'start',
            sortable: false,
            value: 'lanswitchId',
          });
        }
        if (this.showDeleteButton) {
          this.headers.push({
            text: '',
            sortable: false,
            value: 'delete',
          });
        }
    },

    methods: {
        /**
         *  Button click deleteItem
         *  Deletes the last lanswitch from the array of lanswitches.
         *  This removes that lanswitch config from the table.
         */
        deleteItem () {
            this.lanswitches.pop();
        },

        /**
         *  Method to create a unique HTML element id used for automatic testing
         */
        createElementId(element, item) {
            return element+"-"+item.lanswitchId;
        }
    }
  }
</script>